<div *ngIf="user.access!=='member'" id="mySidenav" class="sidenav">
  <a href="javascript:;" routerLink="/">
    <img class="logo" src={{logo}}>
  </a>
  <sng-menu></sng-menu>
</div>

<div [attr.id]="user.access !== 'member' ? 'main' : null">
  <app-header></app-header>
  <div class="app-layout container">
    <div class="row">
      <div class="col-md-12">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
  <div *ngIf="user.access==='member'">
    <sng-footer></sng-footer>
  </div>
</div>
<div id="menu_overlay" (click)="closeNav()">
</div>
